'use client';

import { observer } from 'mobx-react';
import Modal from '../commonUi/Modal';
import { getStore } from '~/mobx/AppStore';
import { MessageModalTypes } from '~/definitions/messageModal';
import { useEffect, useCallback } from 'react';

interface Props {
    type: MessageModalTypes;
    message: string | JSX.Element;
    isOpen: boolean;
    onClose: () => void;
}

const MessageModal = (props: Props) => {
    const textClassnames = 'w-full';
    const errorClassnames = props.type === 'error' ? 'text-red-600' : '';
    const contentClassnames = [textClassnames, errorClassnames].join(' ');

    const content = <div className={contentClassnames}>{props.message}</div>;

    return (
        <Modal id={'message-modal'} isOpen={props.isOpen} onClose={props.onClose}>
            {content}
        </Modal>
    );
};

const MessageModalWithStore = () => {
    const messageModalStore = getStore().messageModalStore;

    const onClose = useCallback(() => {
        messageModalStore.resetToDefault();
    }, [messageModalStore]);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && messageModalStore.isOpen) {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [messageModalStore.isOpen, onClose]);

    return (
        <MessageModal
            type={messageModalStore.type}
            message={messageModalStore.message}
            isOpen={messageModalStore.isOpen}
            onClose={onClose}
        />
    );
};

export default observer(MessageModalWithStore);
